import React, { type FC, useEffect } from 'react';

import { LICENSE } from 'app/constants/license';
import { Trans, useTranslation } from 'app/lang';
import { getBrandName } from 'app/packages/brand';

import dictionary from './License.dictionary.json';

import styles from './License.module.scss';

export const License: FC = () => {
  const brand = getBrandName();
  const { t } = useTranslation();

  useEffect(() => {
    if (LICENSE[brand]) {
      // @ts-expect-error windowPropertyName - свойство, название которого
      // задается сторонним скриптом и зависит от динамических данных,
      // поэтому мы не можем его типизировать
      window[LICENSE[brand].windowPropertyName].init();
    }
  }, []);

  if (!LICENSE[brand]) {
    return null;
  }

  return (
    <div className={styles.root}>
      <div className={styles.notice}>
        <p>
          <Trans data={dictionary.notice}
                 values={{ site: LICENSE[brand].site, email: LICENSE[brand].email }}
                 components={{
                   a: (
                     <a href={`mailto:${LICENSE[brand].email}`} />
                   ),
                 }} />
        </p>
        <div className={styles.icon}
             id={`anj-${LICENSE[brand].id}`}
             data-anj-seal-id={LICENSE[brand].id}
             data-anj-image-size="40"
             data-anj-image-type="basic-small" />
      </div>
      <p>
        {t(dictionary.sportsbook)}
      </p>
    </div>
  );
};
